import type { IProjectRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { CreateProject } from "@domain/schemas/BI";
import type { ProjectDetail } from "@domain/schemas/workspace";

/**
Project mutations reachable from a team's project inventory row (WP4) - full project membership management is WP5.
*/
@injectable()
export class TeamProjectActionsService {
  @inject(TYPES.IProjectRepository)
  private _projectRepository!: IProjectRepository;

  async createProjectAsync(teamId: string, request: CreateProject): Promise<ProjectDetail> {
    return this._projectRepository.createProjectAsync(teamId, request);
  }

  async renameProjectAsync(projectId: string, newName: string): Promise<ProjectDetail> {
    return this._projectRepository.renameProjectAsync(projectId, newName);
  }

  async deleteProjectAsync(teamId: string, projectId: string): Promise<void> {
    return this._projectRepository.deleteProjectAsync(teamId, projectId);
  }
}
